// extracted by mini-css-extract-plugin
export default {"displaySec":"calander_displaySec__05aiS","textSec":"calander_textSec__dyUqf"};